import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';
import { score2Label, score2Type } from 'enums/response-time-type';

const ResponseTimeRecord = Record({
  responseTimeAvg: 0,
  responseTimeScore: 0,
});

export default class ResponseTime extends ResponseTimeRecord {
  static deserialize(jsonObject = {}) {
    if (!jsonObject) {
      return undefined;
    }

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject), {});

    return new ResponseTime(hydrated);
  }

  get scoreAsLabel() {
    return score2Label(this.responseTimeScore);
  }

  get scoreType() {
    return score2Type(this.responseTimeScore);
  }

  get responseTimeInDays() {
    return Math.round(this.responseTimeAvg);
  }

  get responseTimeInHours() {
    return Math.round(this.responseTimeAvg * 24);
  }
}
